import { render } from "./NewsHistoryData.vue?vue&type=template&id=78209449"
import script from "./NewsHistoryData.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsHistoryData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/newsHistory/NewsHistoryData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78209449"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78209449', __exports__)) {
    console.log('reload')
    api.reload('78209449', __exports__)
  }
  
  module.hot.accept("./NewsHistoryData.vue?vue&type=template&id=78209449", () => {
    console.log('re-render')
    api.rerender('78209449', render)
  })

}


export default __exports__